<script>
import Layout from '@layouts/primary'
import { driverMethods } from '@state/helpers'
import { rrulestr } from 'rrule'
import VueGallery from 'vue-gallery';
import Vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { BASE_URL } from '../../endpoints'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'ViewDriver',
    meta: [{ name: 'description', content: 'ViewDriver' }],
  },
  components: { Layout, VueDropzone: Vue2Dropzone, 'Gallery': VueGallery },
  data() {
    return {
      driver: {},
      index: null,
      fileCount:0,
      images: [

      ],
      imagesObj:[

      ],
      selectedPhotoId:null,
      removePhoto:false,
      editDriver: false,
      managePhotos:false,
      removeDriver:false,
      dropOptions: {
        url: `${BASE_URL}/driver/upload`,
        headers: {
          'id':this.$router.history.current.params.id
        }

      },
      managePhotosHeaders:[
        {text:"Photo",value: "headers"},
        {text:"Delete",value: "headers"},
      ],
      dictionary: {
        attributes: {
          email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          name: {
            required: () => 'Name can not be empty',
            max: 'The name field may not be greater than 10 characters',
            // custom messages
          },
          select: {
            required: 'Select field is required',
          },
        },
      },
    }
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
    this.mountDriverData();
  },
  methods: {
    ...driverMethods,
    getFileCount() {
      if (typeof this.$refs.myVueDropzone.dropzone !== 'undefined') {
        this.fileCount = this.$refs.myVueDropzone.dropzone.files.length
      } else {
        this.fileCount = 0;
      }
    },
    onFileSelected(event){
      this.selectedFile = event.target.files[0];
    },
    mountDriverData(){
      let that  = this;
      let cid = this.$router.history.current.params.id
      this.driverById({id: cid}).then(response => {
        that.driver = this.$store.state.drivers.currentDriver
        that.driver.value = true

        let formattedObj = {
          ...that.driver
        }

        that.driver = formattedObj
        for(const photo of that.driver.photos){
          this.images.push(photo.url)
          this.imagesObj.push(photo)
        }
      })
    },
    update() {
      this.$validator.validateAll()
      this.driver.id = parseInt(this.driver.id)
      this.updateDriver(this.driver).then(d => {
        location.reload()
      })
      this.editDriver = !this.editDriver
    },
    submit() {
      this.driver.id = parseInt(this.driver.id)
      this.deleteDriver(this.driver).then(d => {
        this.$router.push('/admin/driver-center')
        location.reload()
      })
    },
    changeRoute(r) {
      this.$router.push(r)
    },
    rulify(s) {
      if (s) {
        return rrulestr(s).toText().toUpperCase();
      }
      else
        return "No Schedule"
    },
    deletePhoto(photo){
      this.selectedPhotoId = this.images.indexOf(photo)
      // console.log(this.selectedTypeID)
      this.removePhoto = true
    },
    actuallyDeletePhoto(){
      let obj = this.imagesObj.find(obj => obj.url === this.images[this.selectedPhotoId]);
      let photoID = parseInt(obj.id)
      this.deleteDriverPhoto({Id:photoID}).then(()=>{
        location.reload();
      })
    },
    closePhotos(){
      // this.images = [];
      // this.imagesObj = [];
      // this.mountDriverData();
      this.getFileCount();
      this.managePhotos = false;
      this.removePhoto=false;
      if(this.fileCount>0){
        location.reload();
      }

    }
  }
}
</script>

<template>
  <Layout>
    <VContainer grid-list-md>
      <h2>View Driver</h2>
      <VCard class="v-card-padding top-blue client-card">
        <p><i class="fas fa-user" /> {{ driver.name }} | {{ driver.username }}</p>
        <p><i class="fas fa-mobile-alt" /> {{ driver.mobile }}</p>
        <p><i class="fas fa-envelope" /> {{ driver.email }}</p>
        <p><i class="fas fa-phone" /> {{ driver.emergency_contact_name }} - {{ driver.emergency_contact_no }}</p>
        <p>{{ driver.schedule_string }}</p>
        <VSpacer />
        <VLayout
          wrap
        >
          <VFlex
            xs12
            sm12
            md4
            lg3
          >
            <VBtn
              color="blue"
              block
              outline
              @click.native="editDriver = !editDriver"
            >
              Edit Driver Details
            </VBtn>
          </VFlex>
          <VFlex
            xs12
            sm6
            md4
            lg3
          >
            <VBtn
              color="green"
              block
              @click.native="managePhotos = !managePhotos"
            >
              Manage Photos
            </VBtn>
          </VFlex>

          <VFlex
            xs12
            sm6
            md4
            lg3
          >
            <VBtn
              v-if="this.$store.getters['auth/getUserRole'] == 'Admin'"
              color="orange"
              block
              @click.native="removeDriver = !removeDriver"
            >
              Delete
            </VBtn>
          </VFlex>
        </VLayout>
      </VCard>
      <!-- Update DRIVER MODAL -->
      <VLayout
        row
        justify-center
      >
        <VDialog
          v-model="editDriver"
          persistent
          max-width="500px"
          scrollable
        >
          <VCard>
            <VCardText>
              <VContainer grid-list-md>
                <h2>Update Driver: {{ driver.username }}</h2>
                <VLayout wrap>

                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="driver.name"
                      label="Name"
                      required
                      data-vv-name="name"
                    />
                  </VFlex>

                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="driver.mobile"
                      v-validate="'integer'"
                      label="Mobile"
                      required
                      data-vv-name="mobile"
                    />
                  </VFlex>

                  <VFlex xs12>
                    <VTextField
                      v-model="driver.email"
                      v-validate="'email'"
                      data-vv-name="email"
                      label="Email"
                      required
                    />
                  </VFlex>

                  <VFlex
                    xs12
                  >
                    <VTextField
                      v-model="driver.password"
                      label="Password"
                      data-vv-name="password"
                      required
                    />
                  </VFlex>
                  <VFlex xs6>
                    <VTextField
                      v-model="driver.drivers_licence_no"
                      data-vv-name="licence_no"
                      label="Drivers License No."
                      required
                    />
                  </VFlex>

                  <VFlex
                    xs6
                  >
                    <VTextField
                      v-model="driver.drivers_licence_expiry"
                      label="Expiry Date"
                      data-vv-name="drivers_licence_expiry"
                      required
                    />
                  </VFlex>

                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="driver.emergency_contact_name"
                      v-validate="'required'"
                      label="Emergency Contact"
                      data-vv-name="emergency_contact_name"
                      required
                    />
                  </VFlex>

                  <VFlex
                    xs12
                    sm6
                  >
                    <VTextField
                      v-model="driver.emergency_contact_no"
                      v-validate="'required'"
                      label="Emergency Phone"
                      data-vv-name="emergency_contact_no"
                      required
                    />
                  </VFlex>
                  <VSpacer />
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      outline
                      @click.native="editDriver = !editDriver"
                    >
                      Close
                    </VBtn>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      @click.native="update()"
                    >
                      Save
                    </VBtn>
                  </VFlex>
                </VLayout>
              </VContainer>
            </VCardText>
          </VCard>
        </VDialog>
      </VLayout>

      <VLayout
        row
        justify-center
      >
        <VDialog
          v-model="managePhotos"
          persistent
          max-width="1024px"
          scrollable
        >
          <VCard>
            <VCardText>
              <VContainer grid-list-md>
                <h2>Manage Photos: {{ driver.username }}</h2>
                <h3>Upload Photos</h3>
                <br>
                <div id="app">
                  <VueDropzone
                    id="drop1"
                    ref="myVueDropzone"
                    :options="dropOptions"
                    @vdropzone-file-added="getFileCount"
                  />
                </div>
                <br>
                <div v-if="this.$store.getters['auth/getUserRole'] == 'Admin'">
                  <h3>Delete Photos</h3>
                  <VDataTable
                    :headers="managePhotosHeaders"
                    :items="images"
                  >
                    <template
                      slot="items"
                      slot-scope="props"
                    >
                      <td class="text-xs-left">
                        <img
                          :src="props.item"
                          style="height:100px"
                        >
                      </td>
                      <td class="justify-center layout px-0">
                        <VIcon
                          small
                          @click="deletePhoto(props.item)"
                        >
                          delete
                        </VIcon>
                      </td>
                    </template>
                  </VDataTable>
                </div>
                <VSpacer />
                <br>
                <VLayout
                  row
                  wrap
                >
                  <VFlex
                    xs12
                    sm12
                    md4
                    lg4
                    offset-md4
                    offset-lg4
                  >
                    <VBtn
                      color="blue"
                      block
                      outline
                      @click.native="closePhotos()"
                    >
                      Close
                    </VBtn>
                  </VFlex>
                </VLayout>
              </VContainer>
            </VCardText>
          </VCard>
        </VDialog>
      </VLayout>

      <VLayout
        row
        justify-center
      >
        <VDialog
          v-model="removePhoto"
          persistent
          max-width="500px"
          scrollable
        >
          <VCard>
            <VCardText>
              <VContainer grid-list-md>
                <h2>Are you sure you want to delete this photo"?</h2>
                <VLayout wrap>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      outline
                      @click.native="removePhoto = !removePhoto"
                    >
                      Close
                    </VBtn>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="orange"
                      block
                      @click.native="actuallyDeletePhoto()"
                    >
                      DELETE
                    </VBtn>
                  </VFlex>
                </VLayout>
              </VContainer>
            </VCardText>
          </VCard>
        </VDialog>
      </VLayout>

      <VLayout
        row
        justify-center
      >
        <VDialog
          v-model="removeDriver"
          persistent
          max-width="500px"
          scrollable
        >
          <VCard>
            <VCardText>
              <VContainer grid-list-md>
                <h2>Are you sure you want to delete {{ driver.username }}?</h2>
                <VLayout wrap>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      outline
                      @click.native="removeDriver = !removeDriver"
                    >
                      Close
                    </VBtn>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="orange"
                      block
                      @click.native="submit()"
                    >
                      DELETE
                    </VBtn>
                  </VFlex>
                </VLayout>
              </VContainer>
            </VCardText>
          </VCard>
        </VDialog>
      </VLayout>

    </VContainer>
    <VContainer>
      <h2>Driver Photos</h2>

      <div>
        <Gallery
          :images="images"
          :index="index"
          @close="index = null"
        />
        <div
          v-for="(image, imageIndex) in images"
          :key="imageIndex"
          class="image"
          :style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '200px' }"
          @click="index = imageIndex"
        />
      </div>

    </VContainer>
  </Layout>
</template>

<style lang="scss" module>
  @import '@design';

  .image {
    float: left;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 5px;
  }
</style>

<style scoped>
  .image {
    float: left;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 5px;
  }

</style>
